import { action, computed, observable, reaction, makeObservable } from 'mobx';
import { ContentLookup, TimeZone, User, X4Unit, X5Lesson } from 'domain/index';
import {
    Control,
    currentTimeZone,
    dateFormat,
    Disposers,
    logger,
    makeTime,
    newValueForSelection,
    StringControl,
    validators
} from 'lib/helpers';

export class ClassroomEditFormStore {
    @observable
    public studentLevelId: number | null = null;

    @observable.ref
    unitOptions: readonly X4Unit[];

    @observable.ref
    readonly unit: Control<X4Unit | null>;

    @observable.ref
    lessonOptions: readonly X5Lesson[];

    readonly lesson: Control<X5Lesson | null>;

    private readonly disposers = new Disposers();

    constructor(private readonly contentLookup: ContentLookup) {
        makeObservable(this);
        this.unit = new Control<X4Unit | null>(
            '', null, validators.required);
        this.lesson = new Control<X5Lesson | null>(
            '', null, validators.required);
        this.unitOptions = this.lessonOptions = [];
        this.setup();
    }

    /****************************************************************************/

    @action
    setLesson(unitId: number, lessonId: number) {
        if (this.studentLevelId == null)
            return;

        this.updateUnitOptions();
        const unitAny: any = { Id: unitId };
        const lessonAny: any = { Id: lessonId };
        this.unit.setValue(newValueForSelection(this.unitOptions, unitAny));
        this.updateLessonOptions();
        this.lesson.setValue(newValueForSelection(this.lessonOptions, lessonAny));
    }

    @action
    markAllTouched() {
        [
            this.unit, this.lesson
        ].forEach(x => x.markTouched());
    }

    private setup() {
        const fireImmediately = { fireImmediately: true } as const;
        // update select options
        this.disposers.add(
            reaction(
                () => this.studentLevelId,
                this.updateUnitOptions,
                fireImmediately),
            reaction(
                () => this.unit.value,
                this.updateLessonOptions,
                fireImmediately));
    }

    @action
    private updateUnitOptions = () => {
        const levelId = this.studentLevelId;
        this.unitOptions = [];
        if (levelId !== null && levelId !== undefined) {
            const level = this.contentLookup.X3LevelById[levelId];
            this.unitOptions = level.Units!;
        }
        this.unit.setValue(newValueForSelection(this.unitOptions, this.unit.value));
    };

    @action
    private updateLessonOptions = () => {
        const unit = this.unit.value;        
        this.lessonOptions = [];
        if (unit != null)
            this.lessonOptions = unit.Lessons!;
        this.lesson.setValue(newValueForSelection(this.lessonOptions, this.lesson.value));
    };

    dispose = () => {
        this.disposers.dispose();
    };

}
